import React, { useState, useEffect } from 'react';
import FieldNode from '../fields/FieldNode';
import { CloseSquare } from '../../atoms/Tree/Icons';
import ActionIcons from '../../atoms/Tree/ActionIcons';
import { StyledTreeItem } from '../../atoms/Tree/Component';
import { Grid, makeStyles, Tooltip, Typography, withStyles } from '@material-ui/core';
import TreeView from '@material-ui/lab/TreeView';
import { useSelector, useDispatch } from 'react-redux';
import { getElementToCopy, getElementOnFocus, getlatestFieldAdded, getReRender, getInnerScreenRender, getNodeExpanded } from '../../../store/global/selectors';
import { cloneClusterlet } from '../../../store/constructs/clusterlets/actions';
import { handleSnackBar, setElementToCopy } from '../../../store/global/actions';
import { newIndexForCopiedItem } from '../../../services/entities/common';
import { getTemplatecluserletMessages } from '../../../store/constructs/templated_clusterlet/selectors'
import Alert from '@material-ui/lab/Alert';
import { invokeGetService } from "../../../store/global/actions";
import { findParentIds } from '../../../config/fields';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Skeleton } from '@material-ui/lab';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';


const useStyles = makeStyles({
    root: {
        minHeight: 500,
        height: '100%',
        flexGrow: 2,
        maxWidth: 400,
        padding: 10
    },
});

const CustomTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFF4E5',  
      color: '#663C00', 
      fontSize: theme.typography.pxToRem(13),
    },
    arrow: {
        color: "#FFF4E5"
    }
  }))(Tooltip);

const MessageRootLabel = ({ content, event, setAction, messages=[], allFields, eventMessage, msgReusedEvents, fieldsForMsg }) => {
    const dispatch = useDispatch();

    const elementToCopy = useSelector(getElementToCopy);

    let fieldName = '';


    const copyItem = ({ id, ...rest }) => {
        dispatch(setElementToCopy({ id, type: 'message' }));
        dispatch(handleSnackBar({ open: true, message: "Item copied", severity: "success" }));
    }

    const pasteItem = ({ id, ...rest }) => {

        let sourceItem = '';

        if (elementToCopy.type == 'field') {

            sourceItem = allFields.find(field => elementToCopy.id == field.id);
            sourceItem = { ...sourceItem, parent: [{ ...sourceItem.parent, type: 'message' }] };

            if (sourceItem == null) {
                dispatch(handleSnackBar({ open: true, message: "Error while copying", severity: "error" }));
            }

            const newIndexArray = newIndexForCopiedItem(fieldsForMsg);
            const duplicateField = fieldsForMsg.filter((field) => field.name === sourceItem.name)
            if (duplicateField.length > 0) {
                fieldName = `${sourceItem.name}_copy${newIndexArray + 1}`
            }
            else
                fieldName = sourceItem.name

            dispatch(cloneClusterlet({ selectedNode: sourceItem, name: fieldName, sectionParentId: eventMessage.id })).then(() => {
                //dispatch(setElementToCopy({}))
                dispatch(handleSnackBar({ open: true, message: "Item copied", severity: "success" }));
            })

        } else if (elementToCopy.type == 'message') {

            sourceItem = messages.find(msg => elementToCopy.id == msg.id);
            sourceItem = { ...sourceItem, parent: [{ ...sourceItem.parent, type: 'message' }] };

            if (sourceItem == null) {
                dispatch(handleSnackBar({ open: true, message: "Error while copying", severity: "error" }));
            }

            /** Instead of directly copying the message, we have to find all root level fields and copy them */
            const messageRootLevelFields = allFields.filter(field => field.parent[0].id == elementToCopy.id);

            messageRootLevelFields.forEach(field => {
                dispatch(cloneClusterlet({ selectedNode: field, name: field.name, sectionParentId: eventMessage.id }))
            });

            dispatch(setElementToCopy({}))
            dispatch(handleSnackBar({ open: true, message: "Item copied", severity: "success" }));
        }
    }

    let actions = {
        add: { id: (eventMessage?._id !== undefined) ? eventMessage._id : "", action: 'create_field', tooltip: 'Add a field', item: 'message', perform: setAction, disabled: event?.messageFromTemplate ? true : false },
        // copy: { id: (eventMessage?._id !== undefined) ? eventMessage._id : "", action: 'copy_message', tooltip: 'Copy event type', item: 'message', perform: copyItem, disabled: event?.messageFromTemplate ? true : false },
        // rename: { id: (eventMessage?._id !== undefined) ? eventMessage._id : "", action: 'rename_event_type', tooltip: 'Rename event type', item: 'message', perform: setAction, disabled: event?.messageFromTemplate ? true : false },

    }

    const handleMessageRootClick = () => {
        setAction({ action: "rename_event_type" })
    }

    return (
        // The event type is used in multiple events {events.join(", ")}. Updating this field will affect these events.
        <Grid container spacing={5} style={{padding: '10px'}} id="message_root">
            <Grid item xs={8} alignItems="left" style={{flexDirection: 'row', display: 'flex', gap: '0.3rem', alignItems: 'center'}} onClick={handleMessageRootClick} >
                <span style={{height: 'max-content'}} id="message_root_label">{content}</span> 
                {
                    (msgReusedEvents?.length > 1 && content && content !== '') &&
                    <CustomTooltip placement='bottom' arrow data-value={`The event type is used in multiple events ${msgReusedEvents.join(", ")}. Updating this field will affect these events.`} title={`The event type is used in multiple events ${msgReusedEvents.join(", ")}. Updating this field will affect these events.`}> 
                        <div style={{display: 'flex',justifyContent: 'center', alignItems: 'center', height: 'max-content', padding: '3px', borderRadius: '3px', background: '#FFF4E5', width: 'max-content'}} id='warning_container'>
                            <ErrorOutlineIcon fontSize='1.5rem' color='#663C00'/>
                        </div>
                    </CustomTooltip>
                }
            </Grid>
            <Grid item xs={4} justify="flex-end" >
                <ActionIcons actions={actions} messageId={event?.message} disableBorder={true} />
            </Grid>
        </Grid>
    )
}

export default function MessageTree({ parent, setAction, setMsgReusedEvents, action, item, shouldRerender, msgReusedEvents, itemToExpand , refreshTree, setRefreshTree}) {
    const dispatch = useDispatch();
    const classes = useStyles();
    let parentItem = parent.id !== undefined ? parent?.item?.message : parent
    let messageId = parent.item ? parent.item.message : parent;


    const [selectEvent, setSelectedEvent] = useState(null)
    const [message, setMessage] = useState(item)

    const [fields, setFields] = useState([]);
    const [allFields, setAllFields] = useState([]);
    const [allMessages, setAllMessages] = useState([]);
    const [expandNodes, setExpandNodes] = useState([1])
    const innerScreenRender = useSelector(getInnerScreenRender);
    const nodeExpanded = useSelector(getNodeExpanded);
    const [isLoading, setIsloading] = useState(false);

    const findMessageResusedEvents = (message) => {
        dispatch(invokeGetService('getAllEvents', []))
            .then(response => {
                if (response.data !== undefined) {
                    let eventNames = response.data.filter(event => event.message === message).map(event => event.name);
                    if (setMsgReusedEvents !== undefined) {
                        setMsgReusedEvents(eventNames);
                    }
                }
            });
    };


    useEffect(() => {
        if(messageId !== undefined && messageId !== ""){
            setIsloading(true);
            dispatch(invokeGetService('getMessageData', [parentItem])).then((response) => {
                if (response.status) {
                    if (typeof parent == 'object' && parent.id != undefined) {
                        let selEVent = response.data.events.find(ev => ev._id == parent?.id);
                        setSelectedEvent(selEVent);
    
                        let evMessage = response.data.messages.find(msg => msg._id == parent?.item?.message)
                        setMessage(evMessage);
                        setFields(response.data.fields.filter(field => field.parent[0].id == evMessage?._id))
                        setAllFields(response?.data?.fields)
                        setAllMessages(response.data?.messages ? response.data?.messages : [])
                        let fieldIds = response.data?.fields?.map(item => item._id);
    
                        if (action && action.id) {
                            let sectionLists = [];
                            let parentNodes = findParentIds(sectionLists, response?.data?.fields, action.id)
                            setExpandNodes([1, action.id, ...parentNodes])
                        } else {
                            setExpandNodes([...expandNodes, ...fieldIds?.filter(e => !expandNodes.includes(e))]);
                        }
    
    
                        // if (nodeExpanded != "") {
                        //     if (itemToExpand != null && itemToExpand != undefined) {
                        //         setExpandNodes([1, nodeExpanded, itemToExpand]);
                        //     } else {
                        //         setExpandNodes([1, nodeExpanded]);
                        //     }
                        // } else {
                        //     setExpandNodes([...expandNodes, ...fieldIds?.filter(e => !expandNodes.includes(e))]);
                        // }
    
                        // if(action?.id != undefined &&  action?.id != null) setSelectedNodeItem(action?.id);
                    }
                    else if (typeof parent == 'string' && parent.id == undefined) {
                        let selMsg = response.data.messages.find(msg => msg._id == parent)
                        setMessage(selMsg);
                        setFields(response.data.fields.filter(field => field.parent[0].id == selMsg?._id))
                        setAllFields(response.data.fields)
                        setAllMessages(response.data?.messages ? response.data?.messages : [])
                        let fieldIds = response.data?.fields?.map(item => item._id);
                        if (nodeExpanded != "") setExpandNodes([1, nodeExpanded])
                        else setExpandNodes([...expandNodes, ...fieldIds?.filter(e => !expandNodes.includes(e))]);
                        // setExpandNodes([...expandNodes, ...fieldIds?.filter(e => !expandNodes.includes(e))]);
                    }
    
                }
                setIsloading(false);
            });
            findMessageResusedEvents(messageId);
        }        

    }, [innerScreenRender, refreshTree, shouldRerender, nodeExpanded])


    function expandNode(id) {
        // window.alert("Hello")
        setExpandNodes([...expandNodes, id])
    }

    function collapseNode(id) {
        setExpandNodes(expandNodes?.filter(item => item != id))
    }

    return (

        <>
            {selectEvent !== undefined && selectEvent?.messageFromTemplate && <Grid item>
                <Alert severity="info">Template messages cannot be altered</Alert>
            </Grid>}
            { isLoading ? <SkeletonLoader type="tree" rows={3} />
            
            : message ? 
                <Grid id={"message_tree_container"} row>
                <TreeView
                    className={classes.root}
                    expanded={expandNodes}
                    defaultEndIcon={<CloseSquare />}
                    fullWidth={true}
                    id="message_tree"
                // selected={selectedNodeItem}
                >

                    {/* <StyledTreeItem nodeId={1} collapseNode={collapseNode} expandNode={expandNode} label={<MessageRootLabel content={message.name} event={parentEvent} setAction={setAction} />}> */}
                    <StyledTreeItem 
                        nodeId={1} 
                        classes={{
                            label: "MuiTreeItem-label"
                        }} 
                        collapseNode={collapseNode} 
                        expandNode={expandNode}
                        messageName={message.name} 
                        label={<MessageRootLabel 
                            content={message?.name}     
                            msgReusedEvents={msgReusedEvents} 
                            allFields={allFields} 
                            fieldsForMsg={fields} 
                            eventMessage={message} 
                            event={parent} 
                            setAction={setAction} 
                        />}>

                        {fields.filter(field => field.parent[0].id == message._id).sort((a, b) => a.order - b.order).map((field, fieldIndex) => {
                            return (<FieldNode allFields={allFields} allMessages={allMessages} collapseNode={collapseNode} expandNode={expandNode} field={field} setAction={setAction} messageId={message._id} index={fieldIndex} totalFields={fields.filter(field => field.parent[0].id == message._id).length} onSuccess={() => setRefreshTree(c => c + 1)}/>)
                        })}

                    </StyledTreeItem>

                </TreeView>
                

            </Grid>
            :
            <Grid item xs={12} style={{ height: '73vh' }}>
                <Alert severity="info">No event type configured.</Alert>              
            </Grid>
            }
        </>

    )
}
